const validateAnswer = function (errors, vm, showTip) {
  const { answerConfig: { requireInd, maxAnswerInd }, optionList } = this
  let optionListFilter = optionList.filter(item => item.visibility)
  const valueLen = optionListFilter.filter(item => item.value !== 0).length
  let { maxAnswerNum } = this.answerConfig
  maxAnswerNum *= 1
  
  if (requireInd === '1' && sessionStorage.getItem('descChangeStatus') === '1') {
    if (!valueLen) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
  }
  if (!valueLen) {
    return !errors.length
  }
  if (maxAnswerNum && maxAnswerNum !== 0 && valueLen !== maxAnswerNum && sessionStorage.getItem('descChangeStatus') === '1') {
    errors.push(vm.cvtLang('tipsMaxSort', this.tipsMaxSort).replace('${n}', maxAnswerNum))
  } else if (!maxAnswerNum && valueLen !== optionListFilter.length && sessionStorage.getItem('descChangeStatus') === '1') {
    errors.push(vm.cvtLang('tipsAllSort', this.tipsAllSort))
  } else if (maxAnswerNum === 0 && valueLen < optionListFilter.length) {
    // 可选位数不限
    return false
  } else if (maxAnswerNum > 0 && valueLen < maxAnswerNum) {
    // 指定可选位数
    return false
  }

  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/SortBox/answerValidate.js